import Container from '~/components/common/container';
import Button from '~/components/common/button';
import { JarirRedBrand } from '~/svgs/jarir';
import Image from 'next/image';
import { Translate, useTranslate } from '~/i18n';

import { isJarir } from '~/utils/theme';

const TopSection = ({ content }: any) => {
   const { dir } = useTranslate();

   const { title, subtitle, description, image, buttons, subtitleClassName, titleClassName } =
      content;

   return (
      <div>
         <Container className="grid mt-16 mb-10 text-center lg:hidden py-7 tablet:mt-0 justify-items-center">
            <div className="font-semibold text-center">
               <div className="text-5xl ">{title}</div>
               <div className="text-[#0552bc] text-5xl pt-2">{subtitle}</div>
            </div>
            <div className="grid xs:w-1/2 justify-items-center rtl:pt-1">
               <img src={image} className="mt-6" />
               <div className="text-[#6C757D] text-sm pt-4">{description}</div>
               <div className="flex flex-col">
                  {buttons.map(
                     ({ text, className, onClick, href, labelColor }: any, index: number) => {
                        return (
                           <div key={index} className="w-[240px] my-2">
                              {href ? (
                                 <a href={href} onClick={onClick}>
                                    <Button
                                       className={`!bg-[#0552bc] !h-11 border-0 w-full py-0 ${
                                          className ? className : null
                                       }`}>
                                       {text}
                                    </Button>
                                 </a>
                              ) : (
                                 <Button
                                    onClick={onClick}
                                    className={`!h-11 border-0 w-full py-0 leading-none ${
                                       className ? className : null
                                    }`}>
                                    <span className={labelColor}>{text}</span>
                                 </Button>
                              )}
                           </div>
                        );
                     }
                  )}
               </div>
            </div>
            <div className="uppercase text-[10px] text-[#495057] tracking-widest mt-[26px] leading-[13px]">
               <Translate id="business:built in partnership with" />
            </div>
            <div className="pt-2">
               <JarirRedBrand />
            </div>
         </Container>
         <div className="hidden pb-20 lg:block">
            <Container>
               <div className="flex-col justify-between w-full mt-12 bg-no-repeat bg-contain lg:flex lg:flex-row">
                  <Container>
                     <div className="flex">
                        <div className="w-5/12 px-2 pt-12">
                           <div className=" tracking-[-3.8px] leading-[93px] font-semibold ">
                              <div
                                 className={
                                    titleClassName
                                       ? titleClassName
                                       : `text-[60px] lg:text-[70px] xl:text-[90px]`
                                 }>
                                 {title}
                              </div>
                              <div
                                 className={
                                    subtitleClassName
                                       ? subtitleClassName
                                       : 'text-[#0552bc] text-[50px] lg:text-[60px] xl:text-[90px] rtl:pt-3.5'
                                 }>
                                 {subtitle}
                              </div>
                           </div>
                           <div className="text-[#6C757D] text-[20px]  leading-[33px] tracking-[-0.77px]">
                              {description}
                           </div>
                           {!isJarir && (
                              <div className="flex pt-[20px]">
                                 <div
                                    className="uppercase text-[10px] text-[#343A40] pt-[12px] leading-[13px]"
                                    style={
                                       dir === 'rtl'
                                          ? { letterSpacing: '0px', paddingRight: '1px' }
                                          : { letterSpacing: '2.5px', paddingLeft: '1px' }
                                    }>
                                    <Translate id="business:built in partnership with" />
                                 </div>
                                 <div className="px-3 pt-2">
                                    <JarirRedBrand />
                                 </div>
                              </div>
                           )}

                           <div>
                              <div className="flex mt-[44px] gap-2">
                                 {buttons.map(
                                    (
                                       { text, className, onClick, href, labelColor }: any,
                                       index: number
                                    ) => {
                                       return (
                                          <div key={index} className="w-[240px]">
                                             {href ? (
                                                <a href={href} onClick={onClick}>
                                                   <Button
                                                      className={`!bg-[#0552bc] !h-[53px] border-0 w-full ${
                                                         className ? className : null
                                                      }`}>
                                                      {text}
                                                   </Button>
                                                </a>
                                             ) : (
                                                <Button
                                                   onClick={onClick}
                                                   className={`!h-[53px] border-0 w-full ${
                                                      className && className
                                                   }`}>
                                                   <span className={labelColor}>{text}</span>
                                                </Button>
                                             )}
                                          </div>
                                       );
                                    }
                                 )}
                              </div>
                           </div>
                        </div>
                        <div>
                           <Image src={image} width={705} height={535} />
                        </div>
                     </div>
                  </Container>
               </div>
            </Container>
         </div>
      </div>
   );
};
export default TopSection;
